export const ITEMS_PER_PAGE = 10;

export const INITIAL_COMMENT_STATE = {
  uuid_project: '',
  uuid_task: '',
  task_name: '',
  observations: '',
  control_date: '',
  uuid_allotment: '',
  uuid_lot: '',
  lot_number: '',
  block_number: '',
  allotment_name: '',
};
